import { Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { LoaderService } from '../services/loader.service';
import { AuthenticationService } from '../services/authentication.service';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { NotificationService } from '../services/notification.service';
import { MessageType } from '../@core/common/models/notification.model';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private authenticationService: AuthenticationService, private loader: LoaderService,
    private notificationService: NotificationService, private router: Router,
    private injector: Injector) { }
  intercept(request: HttpRequest<unknown>, next: HttpHandler) {
    this.authenticationService = this.injector.get(AuthenticationService);
    return next.handle(request).pipe(catchError(err => {
      this.loader.isLoading.next(false);
      if (err.status === 401) {
        return this.handleUnauthorized(request, next);
      } else if (err.status === 403) {
        this.notificationService.showNotification(MessageType.ERROR, 'forbidden');
      } else if (err.status === 502 || err.status === 500) {
        this.notificationService.showNotification(MessageType.ERROR, 'Connection Error');
      } else if (err.status === 404) {
        this.notificationService.showNotification(MessageType.ERROR, '404 Not Found');
      }
      // TODO: convert to swtich case
      // const error = err.error.message || err.statusText;
      return throwError(err);
    }));
  }
  handleUnauthorized(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    // Reset here so that the following requests wait until the token
    // comes back from the refreshToken call.
    // get a new token via authentication.refreshToken

    return next.handle(this.logOut(req));
  }

  logOut(request: HttpRequest<any>) {
    this.authenticationService.logout();
    this.notificationService.showNotification(MessageType.ERROR, 'Unauthorized');
    this.router.navigate(['/login']).then();

    return request;
  }
}
